import Vue from 'vue'  //独立router需要引入vue
import VueRouter from 'vue-router' //引入router
import NProgress from "nprogress"; //进入进度条


const routerReplace = VueRouter.prototype.replace

VueRouter.prototype.replace = function replace(location) {
    return routerReplace.call(this, location).catch(error => error)
}

//push
const routerPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter)  //将router注册到vue对象种

const routes = [
  {path:'/', redirect:'/product_mgt'},
  {
    path: '/',
    name: 'Main',
    component: () => import("./views/Main.vue"), //引入后台主模板
    children: [  //后台右侧显示区
      {path:'/product_mgt', name:'ProductMgt',  component: () => import("./views/ProductMgt.vue")},  //产品列表
      {path:'/hesuan/:id', name:'HeSuan',  component: () => import("./views/HeSuan.vue"), props:true},  //核算表格
      {path:'/caigou_mgt', name:'CaiGouMgt',  component: () => import("./views/CaiGouMgt.vue"), props:true},  //采购单列表
      {path:'/caigou/:id', name:'CaiGou',  component: () => import("./views/CaiGou.vue"), props:true},  //采购表格
      // {path:'/caipi_mgt', name:'CaipiMgt',  component: () => import("./views/CaipiMgt.vue")},  //裁片管理
      {path:'/caipi_data_mgt/:id', name:'CaipiDataMgt',  component: () => import("./views/CaipiDataMgt.vue"), props:true},  //产品列表
      {path:'/user_mgt', name:'UserMgt',  component: () => import("./views/UserMgt.vue")},  //用户管理
      {path:'/user_info', name:'UserInfo',  component: () => import("./views/UserInfo.vue")},  //用户信息详情
      {path:'/shenhe_mgt', name:'ShenheMgt',  component: () => import("./views/ShenheMgt.vue")},  //审核管理
      {path:'/setting', name:'Setting',  component: () => import("./views/Setting.vue")},  //审核管理

      // {path:'/task_mgt', name:'TaskMgt',  component: () => import("./views/TaskMgt.vue")},  //管理员任务管理
      // {path:'/tactics',  name:'Tactics', component: () => import("./views/Tactics.vue")},  //策略池管理
      // {path:'/stf_tactics',  name:'StfTactics', component: () => import("./views/StfTactics.vue")},  //员工策略池管理
      // {path:'/task_make', name:'TaskMake', component: () => import("./views/TaskMake.vue")},  //员工任务列表
      // {path:'/stf_mgt',  name:'StfMgt', component: () => import("./views/StfMgt.vue")},  //员工管理
      // {path:'/admin_mgt', name:'AdminMgt', component: () => import("./views/AdminMgt.vue")},  //管理员 
      // {path:'/platform_mgt', name:'PlatformMgt', component: () => import("./views/PlatformMgt.vue")},  //平台管理
      // {path:'/tactics_mgt', name:'TacticsMgt', component: () => import("./views/TacticsMgt.vue")},  //策略管理
      // {path:'/lang_mgt', name:'LangMgt', component: () => import("./views/LangMgt.vue")},  //语言管理
      // {path:'/task_timeout', name:'TaskTimeout', component: () => import("./views/TaskTimeout.vue")},  //任务超时记录
      // {path:'/admin_stat',  component: () => import("./views/AdminStat.vue")},  //管理员统计
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import("./views/Login.vue"),
    meta: { isPublic: true }
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("./views/NotFound.vue"),
  },
]

const router = new VueRouter({
  mode: 'hash',
  // base: '/admin/',
  // base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active'  
})

//路由监听
router.beforeEach((to, from, next) => {
  if (!to.meta.isPublic && !localStorage.getItem('token') && !localStorage.getItem('quanjian')) { //不是公开访问的页面 并且 无token
    Vue.prototype.$message({ type: "error", message: "请先登录" });
    return next('/login')
  }

  // 如果有token并且是公共页面，重定向到/user页面
  // if (to.meta.isPublic && localStorage.getItem('token')) {
  //   return next('/stf_mgt');
  // }

  NProgress.start(); //进度条开始
  next()
})

router.afterEach(() => {
  NProgress.done();  //进度条完成
})

// router.$addRoutes = (routes) => {
//   // 自定义一个$addRoutes的方法
//   // 通过新建一个全新的 Router，然后将新的 Router.matcher 赋给当前页面的管理 Router，以达到更新路由配置的目的。自定义的$addRoutes，就是实现这个功能
//   router.matcher = new VueRouter().matcher;
//   router.addRoutes(routes);
// };




export default router
